<template>
  <div class="help">
    <div class="content">
      <div class="question">常见问题</div>
      <ul>
        <li
          v-for="item in wordList"
          :key="item.id"
          @click="goHelpDetail(item.id)"
        >
          <div class="word">{{ item.question }}</div>
          <div class="youjian"></div>
        </li>
      </ul>
    </div>

    <div class="dibubtn" >
      <button @click="gofankui">意见反馈</button>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Button } from "vant";
import qs from "qs";
import { Dialog } from "vant";
import { Toast } from "vant";

Vue.use(Button);
export default {
  mounted() {

    // this.getToken();
    this.getHelpQuestion();
  },
  data() {
    return {
      wordList: [],
    };
  },
  methods: {
    gofankui() {
      this.$router.push({
        name:'Fankui',
        query:{
          version:this.$route.query.version
        }
      });
    },
    getToken() {
      let token = this.$route.query.token;
      if (token && token !== "") {
        localStorage.setItem("token", token);
      }
    },
    getHelpQuestion() {
        this.$toast.loading({
        message: "数据获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "QUESTIONS",
      });
      this.$axios
        .post("appapi/app/cmsInterface/getCmsInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
             Toast.clear()
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
             Toast.clear()
            res.data.data.forEach((item) => {
              this.wordList.push(item);
            });
          }
        })
        .catch((err) => {
           Toast.clear()
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    goHelpDetail(id) {
      this.$router.push({
        name: "HelpDetail",
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  background-color: #eef4f6;
  min-height: 100vh;
  padding: 2.625rem 2rem 3.25rem 2rem;
}

.content {
  background-color: #ffffff;
  border-radius: 1rem;
  font-size: 2rem;
  margin-bottom: 12.5rem;

  .question {
    font-size: 2rem;
    color: #19212a;
    border-bottom: 1px solid #e5e5e5;
    padding: 2.25rem 0 1.375rem 2rem;
    font-weight: bold;
  }
  ul {
    padding: 0 2rem 0 2rem;
  }
  li {
    position: relative;
    width: 100%;
    border-top: 1px solid #e5e5e5;
    padding: 2.75rem 0 2.25rem 0;
    color: #19212a;
    font-size: 2rem;
  }
  li:first-child {
    border: none;
  }
}
.dibubtn {
  width: 100%;
  background-color: #eef4f6;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  margin-top: 3.25rem;
  padding: 0 2rem 3.25rem 2rem;

  button {
    width: 100%;
    height: 5.5rem;
    background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
    border: none;
    color: #ffffff;
    font-size: 2rem;
    border-radius: 2.75rem;
    line-height: 5.5rem;
  }
}

.youjian {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1.6rem;
  height: 1.6rem;
  background-image: url("../assets/images/right.svg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  transform: translateY(-50%);
}
</style>
<style lang="scss" scoped>
</style>